/** Matches backend rules for custom event URLs (alphanumeric + hyphen, 5–32 chars). */
export const EVENT_ID_PATTERN = /^[a-zA-Z0-9][a-zA-Z0-9-]{3,30}[a-zA-Z0-9]$/;
